<template>
  <!-- ヘッダーエリア -->
  <header class="l-header l-header--onboarding">
    <!-- ヘッダーコンテンツ: ロゴ -->
    <h1 class="l-header-logo">
      <a class="l-header-logo__link" :href="headerData.topUrl">
        <img src="/assets/img/pushone_logo_white_01.png" />
      </a>
    </h1>
  </header>
<!-- /ヘッダーエリア -->
</template>

<script>
export default {
  props: {
    headerData: Object,
  },
};
</script>
